import Vue from 'vue'
import Vuex from 'vuex'
import {suppliersCollection} from '@/FirebaseConfig'
import {cleanObject, secondsToFullTimestamp} from '@/Helper.js'  
Vue.use(Vuex)
export default {
    namespaced:true,
      state: {
        data:{
          name:'',
          address:'',
          phone:'',
          email:'',
          createdAt:'',
          document: '',
        },
        record:{},
        rolesRecord:{},
        Role :{},
        selectedKey: '',
        dialog:false,
      },
      mutations: {
        getAllItems(state, item) {
          Vue.set( state.record, item.id, {...item.data(), createdAt: secondsToFullTimestamp(item.data().createdAt)} )
        },
        clean(state,key){
          Vue.delete(state.record,key)
        }
      },
      actions: {
        getAll:(context)=>{
          context.state.record = {}
          suppliersCollection.onSnapshot(data=>data.docs.map( item => context.commit( 'getAllItems', item  ) ) )
          
        },
        add:context=>{
          if(context.state.selectedKey==''){
            suppliersCollection.add({...context.state.data, createdAt:new Date}).then(()=>{
              context.commit('Helpers/launchSnackbar', 'Se ha registrado un nuevo proveedor correctamente', { root: true })
              cleanObject(context.state.data)})
              context.state.dialog = false
          }else{
            suppliersCollection.doc(context.state.selectedKey).update(context.state.data).then(()=>{
              context.commit('Helpers/launchSnackbar', ' Ha sido modificado correctamente', { root: true })
              cleanObject(context.state.data)})
              context.state.dialog = false
          }
        },
        clean:(context, key)=>{
          suppliersCollection.doc(key).delete().then(()=>{
            context.commit('Helpers/launchSnackbar', ' Ha sido eliminado', { root: true })            
            context.commit('clean',key)})
        },
        get:(context, key)=>{
          suppliersCollection.doc(key).get().then(doc=>{
            context.state.data = doc.data()
            context.state.selectedKey = key
            context.state.dialog = true
          })
        },
        clearForm:(context)=>{
          context.state.dialog = false
          context.state.selectedKey = ''
          context.state.data = {
            name: '',
            createdAt: ''
          }
        },
      },
      getters: {
        record: state => Object.keys(state.record).map(item => ({...state.record[item], key: item }) ),
      },
  }
  